import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionWithIssues: {
		id: 'project-directories.versions.release-version-modal.content.description-with-issues',
		defaultMessage: 'This release contains {issueCountLink}.',
		description: '',
	},
	descriptionWithIssuesCount: {
		id: 'project-directories.versions.release-version-modal.content.description-with-issues-count',
		defaultMessage:
			'{issues, plural, one {{issues} unresolved issue} other {{issues} unresolved issues}}',
		description: '',
	},
	descriptionWithoutIssues: {
		id: 'project-directories.versions.release-version-modal.content.description-without-issues',
		defaultMessage: '{doneIssues} {doneIssues, plural, one {issue} other {issues}}',
		description: '',
	},
	descriptionWithoutIssuesRestMessage: {
		id: 'project-directories.versions.release-version-modal.content.description-without-issues-rest-message',
		defaultMessage: '{issueCountLink} will be released.',
		description: '',
	},
});
